var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import { Auth } from '@whatsper/texterchat-common';
import { useStore } from '../../../../../store/rootStore';
import TOTP from './TOTP';
import WhatsappOTP from './WhatsappOTP';
import s from '../../../Login.module.scss';
const OTP = ({ onSubmit, method, onBack }) => {
    const { loginStore } = useStore();
    const [formData, setFormData] = useState({ code: '', email: '' });
    const [loading, setLoading] = useState(false);
    const isMfaStep = !!loginStore.mfa;
    const isTOTP = method === Auth.Methods.Method.totp;
    const disabled = loading || !formData.code || (isTOTP && !isMfaStep && !formData.email);
    useEffect(() => {
        // Send initial request for WhatsApp OTP 
        if (method === Auth.Methods.Method.whatsapp_otp) {
            onSubmit();
        }
    }, []);
    const onSubmitHandler = (e) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        try {
            e.preventDefault();
            setLoading(true);
            const { code, email } = formData;
            if (isTOTP) {
                yield loginStore.loginWithTOTP(code, email);
            }
            else {
                // WhatsApp OTP
                if (code) {
                    yield onSubmit(code);
                }
                else {
                    yield onSubmit();
                }
            }
        }
        catch (e) {
            console.error(((_a = e.error) === null || _a === void 0 ? void 0 : _a.message) || e);
        }
        finally {
            setLoading(false);
        }
    });
    const renderOTPForm = () => {
        switch (method) {
            case Auth.Methods.Method.whatsapp_otp:
                return (React.createElement(WhatsappOTP, { onSubmitHandler: onSubmitHandler, formData: formData, setFormData: setFormData, loading: loading, disabled: disabled, onBack: onBack }));
            case Auth.Methods.Method.totp:
                return (React.createElement(TOTP, { onSubmitHandler: onSubmitHandler, formData: formData, setFormData: setFormData, loading: loading, disabled: disabled, isMfaStep: isMfaStep, onBack: onBack }));
            default:
                return;
        }
    };
    return React.createElement("div", { className: s.pageWrapper }, renderOTPForm());
};
export default OTP;
